import React from 'react';
import DashboardProfileStatsCard from './dashboardProfileStatsCard/dashboardProfileStatsCard';
import { PostUtil } from '../new-post-new/post-util';
import { useTranslation } from 'react-i18next';

const DashboardProfileStats = ({ service, serviceName }) => {
  const { t: translate } = useTranslation();
  switch (serviceName) {
    case PostUtil.DashboardProfileServiceName.FACEBOOK:
      return (
        <DashboardProfileStatsCard
          service={service}
          name={translate('dashboard.followers')}
          count={service.followers_count}
          profilePicture={service.url}
          serviceName={'FACEBOOK'}
        />
      );
    case PostUtil.DashboardProfileServiceName.INSTAGRAM:
      return (
        <DashboardProfileStatsCard
          service={service}
          name={translate('dashboard.followers')}
          count={service.followers_count}
          profilePicture={service.profile_picture_url}
          serviceName={'INSTAGRAM'}
        />
      );
    case PostUtil.DashboardProfileServiceName.LINKEDIN:
      return (
        <DashboardProfileStatsCard
          service={service}
          name={translate('dashboard.followers')}
          count={service.totalPageFollowers}
          profilePicture={service.url}
          serviceName={'LINKEDIN'}
        />
      );
    case PostUtil.DashboardProfileServiceName.YOUTUBE:
      return (
        <DashboardProfileStatsCard
          service={service}
          name={translate('dashboard.subscribers')}
          count={service.subscriberCount}
          profilePicture={service.picture}
          serviceName={'YOUTUBE'}
        />
      );
    case PostUtil.DashboardProfileServiceName.GBUSINESS:
      return (
        <DashboardProfileStatsCard
          service={service}
          name={translate('dashboard.review_count')}
          count={service.totalReviewCount}
          profilePicture={service.url}
          serviceName={'GBUSINESS'}
        />
      );
    case PostUtil.DashboardProfileServiceName.PINTEREST:
      return (
        <DashboardProfileStatsCard
          service={service}
          name={translate('dashboard.followers')}
          count={service.follower_count}
          profilePicture={service.url}
          serviceName={'PINTEREST'}
        />
      );
    case PostUtil.DashboardProfileServiceName.TIKTOK:
      return (
        <DashboardProfileStatsCard
          service={service}
          name={translate('dashboard.followers')}
          count={service.follower_count}
          profilePicture={service.url}
          serviceName={'TIKTOK'}
        />
      );
    case PostUtil.DashboardProfileServiceName.TWITTER:
      return (
        <DashboardProfileStatsCard
          service={service}
          name={translate('dashboard.followers')}
          count={service.follower_count}
          profilePicture={service.url}
          serviceName={'TWITTER'}
        />
      );
    case PostUtil.DashboardProfileServiceName.THREADS:
      return (
        <DashboardProfileStatsCard
          service={service}
          name={translate('dashboard.followers')}
          count={service.follower_count}
          profilePicture={service.url}
          serviceName={'THREADS'}
        />
      );
    case PostUtil.DashboardProfileServiceName.BLUESKY:
      return (
        <DashboardProfileStatsCard
          service={service}
          name={translate('dashboard.followers')}
          count={service.follower_count}
          profilePicture={service.url}
          serviceName={'BLUESKY'}
        />
      );
    case PostUtil.DashboardProfileServiceName.SNAPCHAT:
      return (
        <DashboardProfileStatsCard
          service={service}
          name={translate('dashboard.followers')}
          count={service.follower_count}
          profilePicture={service.url}
          serviceName={'SNAPCHAT'}
        />
      );
    default:
      return null;
  }
};

export default DashboardProfileStats;
